module.exports = __webpack_public_path__ + "img/17_5.d4609ee5.png";